type Draft = { learnerId: string; phone: string; promo?: { code: string; subtotalEgp: number; discountPercent: number; discountEgp: number; amountEgp: number } | null; review?: boolean; command?: { key: string; fingerprint: string }; savedAt: number };
const prefix = "kidix:checkout-draft:";
export function readCheckoutDraft(storage: Pick<Storage, "getItem" | "removeItem">, userId: string, courseId: string): Draft | null {
  const key = `${prefix}${userId}:${courseId}`;
  try {
    const draft = JSON.parse(storage.getItem(key) ?? "null") as Draft | null;
    if (draft && typeof draft.learnerId === "string" && typeof draft.phone === "string" && Date.now() - draft.savedAt < 24 * 60 * 60_000) return draft;
  } catch { /* Invalid drafts are not used. */ }
  storage.removeItem(key); return null;
}
export function saveCheckoutDraft(storage: Pick<Storage, "setItem">, userId: string, courseId: string, draft: Omit<Draft, "savedAt">) {
  try { storage.setItem(`${prefix}${userId}:${courseId}`, JSON.stringify({ ...draft, savedAt: Date.now() })); } catch { /* A blocked browser store does not block ordering. */ }
}
export function removeCheckoutDraft(storage: Pick<Storage, "removeItem">, userId: string, courseId: string) { storage.removeItem(`${prefix}${userId}:${courseId}`); }
export function clearCheckoutDrafts(storage: Storage) {
  for (let index = storage.length - 1; index >= 0; index--) { const key = storage.key(index); if (key?.startsWith(prefix)) storage.removeItem(key); }
}
